<template>
  <section :id="section" ref="hero" class="section cv-fullwidth light-gradient active">
    <div class="container">
      <div class="row no-gutters align-items-center cv-fullheight">
        <div class="col-12 col-sm-8 offset-sm-2 col-xl-7 offset-xl-0">
          <h2 v-html="title" class="wow fadeInRightShort subtitle"></h2>
          <h4 v-html="subtitle" class="wow fadeInRightShort delay-04s text-gray"></h4>
        </div>
        <!-- /left -->

        <div v-if="formFields" class="col-12 col-sm-6 offset-sm-3 col-xl-3 offset-xl-1">
          <div class="form-wrapper text-center wow fadeInUpShort delay-1s">
            <h4>Register</h4>
            <h6>Enter your contact details below</h6>
            <validation-field
              v-for="field in formFields"
              ref="formItems"
              :key="field.id"
              :submitted="submitted"
              class="input-group"
              :field="field"
            ></validation-field>
            <div class="input-group text-left captcha">
              <small>
                This site is protected by reCAPTCHA and the Google
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
              </small>
            </div>
            <vue-recaptcha
              ref="recaptcha"
              badge="invisible"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired"
              size="invisible"
              sitekey="6LfPC6wUAAAAAD2hFmJH7lM647zSo4L4al36zu_b"
            ></vue-recaptcha>
            <button
              :disabled="status !== ''"
              @click="submit"
              class="btn btn-circle"
              :class="{
                'btn-primary': status === '',
                'btn-default is-loading': status == 'submit',
                'btn-success': status === 'success',
                'btn-danger': status === 'fail'
              }"
            >
              <i
                :class="{
                  'icon-arrow-right': status === '',
                  'icon-refresh': status === 'submit',
                  'icon-check': status === 'success',
                  'icon-close': status === 'fail'
                }"
              ></i>
            </button>
          </div>
        </div>
        <!-- /right -->
      </div>
    </div>
  </section>
</template>

<script>
import { currentSection } from './../../mixins/changeSection';
import emailApi from '../../api/email.api';
import VueRecaptcha from 'vue-recaptcha';
export default {
  name: 'hero-register',
  components: {
    'vue-recaptcha': VueRecaptcha,
    ValidationField: () => import('../validation/ValidationField')
  },
  props: ['section', 'title', 'subtitle', 'formFields', 'image'],
  data() {
    return {
      status: '',
      submitted: false
    };
  },
  mixins: [currentSection],
  methods: {
    submit() {
      if (!this.validate()) {
        return;
      } else {
        const test = this.$refs.recaptcha.execute();
      }
    },
    onCaptchaVerified(recaptchaToken) {
      const self = this;
      self.status = 'submit';
      self.$refs.recaptcha.reset();

      const form = self.formFields.reduce((acc, cur) => ({ ...acc, [cur.id]: cur.data }), {});
      form.recaptchaToken = recaptchaToken;
      emailApi
        .sendEmail(form)
        .then((res) => {
          if (res) {
            self.submitted = true;
            self.setStatus('success');
            console.log('response', res);
          } else {
            self.setStatus('fail');
            console.error('error');
          }
        })
        .catch((err) => {
          self.setStatus('fail');
          console.error(err);
        });
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    setStatus(status) {
      const self = this;
      self.status = status;
      setTimeout(() => {
        self.status = '';
      }, 5000);
    },
    validate() {
      let isValid = true;
      for (let i = 0; i < this.formFields.length; i++) {
        if (!this.$refs.formItems[i].validate()) {
          isValid = false;
        }
      }
      return isValid;
    }
  }
};
</script>
<style>
.grecaptcha-badge {
  visibility: hidden;
}
</style>
